import { render } from "./LocationsIrvine.vue?vue&type=template&id=57497ff8"
import script from "./LocationsIrvine.vue?vue&type=script&lang=js"
export * from "./LocationsIrvine.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__